import React, { FC } from 'react'
import { Text, Flex, Box } from '@chakra-ui/react'

const DetailDisplay: FC<{ label: string; value: string }> = ({ label, value }) => {
  return (
    <Flex
      align={{ base: 'flex-start', md: 'center' }}
      direction={{ base: 'column', md: 'row' }}
      py={1}
    >
      <Box w={{ base: '100%', md: '180px' }} flexShrink={0} mb={{ base: 1, md: 0 }}>
        <Text
          color="gray.500"
          fontSize="xs"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
        >
          {label}
        </Text>
      </Box>
      <Text fontSize="sm" color="gray.800" fontWeight="medium">
        {value}
      </Text>
    </Flex>
  )
}

export default DetailDisplay
